import {configureStore} from '@reduxjs/toolkit';
import {enableMapSet} from 'immer';

import sessionReducer from '../reducers/sessionReducer';
import billingReducer from '../reducers/billingReducer';
import consumerReducer from '../reducers/consumerReducer';
import accessReducer from '../reducers/accessReducer';

enableMapSet();

export const store = configureStore({
    reducer: {
        access: accessReducer,
        session: sessionReducer,
        billing: billingReducer,
        consumer: consumerReducer
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                // Ignore these action types
                ignoredActions: ['payload', 'session/addTranslatedText', 'meta.arg.input.device', 'meta.arg.translation'],
                // Ignore these field paths in all actions
                ignoredActionPaths: ['payload.device', 'payload', 'session/addTranslatedText', 'meta.arg.input.device', 'meta.arg.translation'],
                // Ignore these paths in the state
                ignoredPaths: ['session.translations', 'session.input.device', 'payload.device', 'payload', 'session.outputs', 'payload.device',
                    'session.currentTranslations', 'consumer.translationMap',
                    'session.recognizedTexts.0', 'session.recognizedTexts.1', 'session.recognizedTexts.2', 'session.recognizedTexts.3',
                    'session.recognizedTexts.4', 'session.recognizedTexts.5', 'session.recognizedTexts.6', 'session.recognizedTexts.7'
                ]
            }
        })
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch


